module.exports = __webpack_public_path__ + "img/Dash_mini_info.6bcfb8b2.svg";